<div #multipleDonut></div>
<div class="row">
    <div class="poll-chart-wrapper">
        <div class="poll-chart-container" *ngFor="let circleChart of config.data; index as i">
            <button class="round-button" [ngClass]="{'active': i == selectedYear}" (click)="changeYear(circleChart.year)">{{circleChart.year}}</button>
        </div>
    </div>
</div>